import { makeBEM } from "../global/utils";
import Icon from "./Icon";
import ReloadIcon from "./ReloadIcon";

function FormButton({  
                    children, 
                    customClass='', 
                    isSubmitting=false,
                    icon="check", 
                    buttonType="submit",
                    buttonText='Button',
                    ...rest
                }) 
{

    const moduleName = 'form-btn';

    const showLoadingStatus = () => {
        if ( !isSubmitting ) {
            return '';
        }

        return <ReloadIcon name="loading" size={2} customClass={makeBEM('form', 'loading-status-icon')} />;
    }

    const renderInside = () => {
        return icon ? <Icon name={icon}/> : buttonText;
    }

    return (
        <button
            {...rest}
            className={ `btn btn--icon btn--molding ${moduleName}  ${customClass}` }
        >
            { !isSubmitting ? ( renderInside() )  : showLoadingStatus() }
            {children ? children : ''}
        </button>
    )
}

export default FormButton;